document.addEventListener("DOMContentLoaded", () => {
	const productImageBackgroundsEnabled =
		document.body.dataset.matchProductImageBackgrounds === "true"

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					entry.target.classList.add("is-visible")
					observer.unobserve(entry.target)
				}
			})
		},
		{
			threshold: 0.05,
			rootMargin: "0px 0px 20% 0px",
		}
	)

	document.querySelectorAll(".reveal").forEach((element, index) => {
		element.style.transitionDelay = `${Math.min(index * 70, 280)}ms`
		observer.observe(element)
	})

	document.querySelectorAll("[data-product-gallery]").forEach((gallery) => {
		const stage = gallery.querySelector("[data-product-gallery-stage]")
		const mainImage = gallery.querySelector(".main-product__image")
		const thumbnails = [...gallery.querySelectorAll("[data-product-gallery-image]")]
		let activeIndex = thumbnails.findIndex((thumbnail) => thumbnail.classList.contains("is-active"))
		let startPoint = null

		if (!stage || !mainImage || thumbnails.length < 2) return
		if (activeIndex < 0) activeIndex = 0

		const showImage = (index) => {
			activeIndex = (index + thumbnails.length) % thumbnails.length
			const thumbnail = thumbnails[activeIndex]

			mainImage.classList.add("is-changing")
			window.setTimeout(() => {
				mainImage.src = thumbnail.dataset.imageSrc
				mainImage.srcset = thumbnail.dataset.imageSrc
				mainImage.alt = thumbnail.dataset.imageAlt
				mainImage.classList.remove("is-changing")
			}, 110)

			thumbnails.forEach((item, itemIndex) => {
				const isActive = itemIndex === activeIndex
				item.classList.toggle("is-active", isActive)
				item.setAttribute("aria-current", isActive ? "true" : "false")
			})
		}

		thumbnails.forEach((thumbnail, index) => {
			thumbnail.addEventListener("click", () => showImage(index))
		})

		stage.addEventListener("pointerdown", (event) => {
			startPoint = { x: event.clientX, y: event.clientY }
		})

		stage.addEventListener("pointerup", (event) => {
			if (!startPoint) return
			const deltaX = event.clientX - startPoint.x
			const deltaY = event.clientY - startPoint.y
			startPoint = null

			if (Math.abs(deltaX) < 42 || Math.abs(deltaX) < Math.abs(deltaY)) return
			showImage(activeIndex + (deltaX < 0 ? 1 : -1))
		})

		stage.addEventListener("pointercancel", () => {
			startPoint = null
		})
	})

	document.querySelectorAll("[data-featured-collection-load-more]").forEach((button) => {
		const section = button.closest(".featured-collection-editorial")

		button.addEventListener("click", () => {
			const nextProducts = [...section.querySelectorAll("[data-featured-collection-hidden-product]")].slice(0, 12)

			nextProducts.forEach((product, index) => {
				product.hidden = false
				product.removeAttribute("data-featured-collection-hidden-product")
				product.style.transitionDelay = `${Math.min(index * 70, 280)}ms`
				observer.observe(product)
			})

			applyProductImageBackgrounds(section)

			if (!section.querySelector("[data-featured-collection-hidden-product]")) {
				button.hidden = true
				button.parentElement.classList.add("featured-collection-editorial__actions--single")
			}
		})
	})

	const setProductImageBackground = (image) => {
		const container = image.closest(
			".product-tile__visual, .main-product__media, .cart-line__media, .header-search__result-media"
		)

		if (!container || !image.naturalWidth || !image.naturalHeight) {
			return
		}

		try {
			const size = 48
			const canvas = document.createElement("canvas")
			const context = canvas.getContext("2d", { willReadFrequently: true })

			if (!context) {
				return
			}

			canvas.width = size
			canvas.height = size
			context.drawImage(image, 0, 0, size, size)

			const pixels = context.getImageData(0, 0, size, size).data
			const colors = new Map()
			const addPixel = (x, y) => {
				const offset = (y * size + x) * 4
				const alpha = pixels[offset + 3]

				if (alpha < 128) {
					return
				}

				const red = pixels[offset]
				const green = pixels[offset + 1]
				const blue = pixels[offset + 2]
				const key = `${Math.round(red / 24) * 24},${Math.round(green / 24) * 24},${Math.round(blue / 24) * 24}`
				const color = colors.get(key) || { count: 0, red: 0, green: 0, blue: 0 }

				color.count += 1
				color.red += red
				color.green += green
				color.blue += blue
				colors.set(key, color)
			}

			for (let coordinate = 0; coordinate < size; coordinate += 1) {
				addPixel(coordinate, 0)
				addPixel(coordinate, size - 1)
				addPixel(0, coordinate)
				addPixel(size - 1, coordinate)
			}

			const dominantColor = [...colors.values()].reduce(
				(current, color) => (color.count > current.count ? color : current),
				{ count: 0 }
			)

			if (dominantColor.count) {
				container.style.backgroundColor = `rgb(${Math.round(dominantColor.red / dominantColor.count)}, ${Math.round(dominantColor.green / dominantColor.count)}, ${Math.round(dominantColor.blue / dominantColor.count)})`
			}
		} catch (error) {
			// Keep the white CSS fallback if the image cannot be read by canvas.
		}
	}

	const applyProductImageBackgrounds = (scope = document) => {
		if (!productImageBackgroundsEnabled) {
			return
		}

		scope
			.querySelectorAll(
				".product-tile__image, .main-product__image, .cart-line__image, .header-search__result-media img"
			)
			.forEach((image) => {
				if (image.complete) {
					setProductImageBackground(image)
				} else {
					image.addEventListener("load", () => setProductImageBackground(image), {
						once: true,
					})
				}
			})
	}

	applyProductImageBackgrounds()

	document.addEventListener("click", (event) => {
		if (
			event.defaultPrevented ||
			event.button !== 0 ||
			event.metaKey ||
			event.ctrlKey ||
			event.shiftKey ||
			event.altKey
		) {
			return
		}

		const link = event.target.closest?.("a[href]")
		if (!link || link.target || link.hasAttribute("download")) {
			return
		}

		const url = new URL(link.href, window.location.href)
		if (
			url.origin !== window.location.origin ||
			!/^\/collections\/[^/]+\/?$/.test(url.pathname) ||
			url.searchParams.has("filter.v.availability")
		) {
			return
		}

		url.searchParams.set("filter.v.availability", "1")
		event.preventDefault()
		window.location.assign(url)
	})

	let cartFetchPromise = null

	const fetchCart = () => {
		if (!cartFetchPromise) {
			cartFetchPromise = fetch("/cart.js", {
				headers: { Accept: "application/json" },
			})
				.then((response) => {
					if (!response.ok) {
						throw new Error("Cart fetch failed")
					}

					return response.json()
				})
				.finally(() => {
					cartFetchPromise = null
				})
		}

		return cartFetchPromise
	}

	const findCartItemByVariant = (cart, variantId) => {
		return cart.items.find(
			(item) => String(item.variant_id) === String(variantId)
		)
	}

	const getRemainingInventory = (cart, variantId, maxQuantity) => {
		if (maxQuantity === null) {
			return null
		}

		const item = findCartItemByVariant(cart, variantId)
		const currentInCart = item ? item.quantity : 0
		return Math.max(maxQuantity - currentInCart, 0)
	}

	const cartCountBadges = document.querySelectorAll("[data-cart-count]")

	const updateCartCount = (cart) => {
		const count = cart?.item_count || 0
		cartCountBadges.forEach((badge) => {
			badge.textContent = count
			badge.hidden = count === 0
		})

		if (cartDrawer) {
			renderCartDrawer(cart)
		}

		window.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart } }))
	}

	const cartDrawer = document.querySelector("[data-cart-drawer]")
	const cartDrawerPanel = document.querySelector("[data-cart-drawer-panel]")
	const cartDrawerContent = document.querySelector("[data-cart-drawer-content]")
	const cartDrawerFooter = document.querySelector("[data-cart-drawer-footer]")
	const cartDrawerCount = document.querySelector("[data-cart-drawer-count]")
	let cartDrawerCart = null
	let cartDrawerReturnFocus = null
	let cartInventoryMap = JSON.parse(document.querySelector("[data-cart-drawer-inventory]")?.textContent || "{}")

	const money = (cents, currency) =>
		new Intl.NumberFormat("en-US", {
			style: "currency",
			currency: currency || window.Shopify?.currency?.active || "USD",
		}).format(Number(cents || 0) / 100)

	const escapeHtml = (value) =>
		String(value || "").replace(/[&<>'"]/g, (character) => ({
			"&": "&amp;",
			"<": "&lt;",
			">": "&gt;",
			"'": "&#39;",
			'"': "&quot;",
		}[character]))

	const renderCartDrawer = (cart) => {
		if (!cartDrawer || !cartDrawerContent || !cartDrawerFooter) return
		cartDrawerCart = cart
		if (cartDrawerCount) cartDrawerCount.textContent = `(${cart.item_count || 0})`

		if (!cart.item_count) {
			cartDrawerContent.innerHTML = '<div class="cart-drawer__empty"><p>Your cart is empty.</p><a class="button button--solid" href="/collections">Browse cards</a></div>'
			cartDrawerFooter.innerHTML = ""
			return
		}

		cartDrawerContent.innerHTML = `<div class="cart-drawer__items">${cart.items.map((item) => `
			<article class="cart-drawer__item">
				<a href="${escapeHtml(item.url)}"><img class="cart-drawer__image" src="${escapeHtml(item.image || "")}" alt="${escapeHtml(item.product_title)}"></a>
				<div class="cart-drawer__item-info">
					<p class="cart-drawer__item-title"><a href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a></p>
					${item.variant_title && item.variant_title !== "Default Title" ? `<p class="cart-drawer__item-variant">${escapeHtml(item.variant_title)}</p>` : ""}
					<div class="cart-drawer__item-controls">
						<div class="cart-drawer__quantity"><button type="button" data-cart-drawer-change="-1" data-cart-line-key="${escapeHtml(item.key)}" aria-label="Decrease quantity">−</button><input class="cart-drawer__quantity-value" type="text" inputmode="numeric" pattern="[0-9]*" value="${item.quantity}" data-cart-drawer-input data-cart-line-key="${escapeHtml(item.key)}" aria-label="Quantity for ${escapeHtml(item.product_title)}"><button type="button" data-cart-drawer-change="1" data-cart-line-key="${escapeHtml(item.key)}" aria-label="Increase quantity" ${(cartInventoryMap[item.key]?.inventory_limited && item.quantity >= cartInventoryMap[item.key].max_quantity) ? "disabled" : ""}>+</button></div>
						<div class="cart-drawer__price-actions"><p class="cart-drawer__line-price">${money(item.final_line_price, cart.currency)}</p><button class="cart-drawer__remove" type="button" data-cart-drawer-remove data-cart-line-key="${escapeHtml(item.key)}" aria-label="Remove ${escapeHtml(item.product_title)} from cart"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7H20M9 7V4H15V7M7 7L8 20H16L17 7M10 11V17M14 11V17"/></svg></button></div>
					</div>
				</div>
			</article>`).join("")}</div>`
		const freeShippingThreshold = Number.parseInt(cartDrawer.dataset.cartFreeShippingThreshold || "0", 10)
		const flatShippingRate = Number.parseInt(cartDrawer.dataset.cartFlatShippingRate || "0", 10)
		const amountRemaining = Math.max(freeShippingThreshold - cart.total_price, 0)
		const shippingCost = amountRemaining ? flatShippingRate : 0
		const cartTotal = cart.total_price + shippingCost
		const shippingProgress = freeShippingThreshold > 0 ? `<section class="cart-drawer__free-shipping" aria-label="Free shipping progress"><div class="cart-drawer__free-shipping-copy"><strong>Free shipping</strong><span>${amountRemaining ? `${money(amountRemaining, cart.currency)} away` : "Unlocked"}</span></div><div class="cart-drawer__free-shipping-track" role="progressbar" aria-valuemin="0" aria-valuemax="${freeShippingThreshold}" aria-valuenow="${Math.min(cart.total_price, freeShippingThreshold)}"><span style="width: ${Math.min((cart.total_price / freeShippingThreshold) * 100, 100)}%"></span></div><p>${amountRemaining ? `Add ${money(amountRemaining, cart.currency)} more for free shipping.` : "Your order qualifies for free shipping."}</p></section>` : ""
		cartDrawerFooter.innerHTML = `<div class="cart-drawer__subtotal"><span>Subtotal</span><strong>${money(cart.total_price, cart.currency)}</strong></div><div class="cart-drawer__shipping-row"><span>Shipping</span><strong>${shippingCost ? money(shippingCost, cart.currency) : "Free"}</strong></div><div class="cart-drawer__total"><span>Total</span><strong>${money(cartTotal, cart.currency)}</strong></div>${shippingProgress}<div class="cart-drawer__actions"><form action="/cart" method="post"><button class="button button--solid cart-drawer__checkout" type="submit" name="checkout">Checkout</button></form><button class="cart-drawer__continue" type="button" data-cart-drawer-close>Continue shopping</button></div>`
	}

	const refreshDrawerInventoryMap = async () => {
		try {
			const response = await fetch("/?section_id=header")
			if (!response.ok) return
			const markup = await response.text()
			const documentFragment = document.createElement("div")
			documentFragment.innerHTML = markup
			const inventoryData = documentFragment.querySelector("[data-cart-drawer-inventory]")?.textContent
			if (!inventoryData) return
			cartInventoryMap = JSON.parse(inventoryData)
			if (cartDrawerCart) renderCartDrawer(cartDrawerCart)
		} catch (error) {}
	}

	const openCartDrawer = async (trigger) => {
		if (!cartDrawer) return
		cartDrawerReturnFocus = trigger || document.activeElement
		cartDrawer.hidden = false
		document.body.classList.add("cart-drawer-is-open")
		cartDrawerPanel?.focus()
		try { const cart = await fetchCart(); updateCartCount(cart); renderCartDrawer(cart); refreshDrawerInventoryMap() } catch (error) {}
	}

	const closeCartDrawer = () => {
		if (!cartDrawer) return
		cartDrawer.hidden = true
		document.body.classList.remove("cart-drawer-is-open")
		cartDrawerReturnFocus?.focus?.()
	}

	document.querySelectorAll("[data-cart-drawer-open]").forEach((trigger) => trigger.addEventListener("click", (event) => {
		event.preventDefault(); openCartDrawer(trigger)
	}))

	cartDrawer?.addEventListener("click", async (event) => {
		if (event.target.closest("[data-cart-drawer-close]")) { closeCartDrawer(); return }
		const change = event.target.closest("[data-cart-drawer-change]")
		const remove = event.target.closest("[data-cart-drawer-remove]")
		if (!change && !remove) return
		const key = (change || remove).dataset.cartLineKey
		const item = cartDrawerCart?.items.find((entry) => entry.key === key)
		const quantity = remove ? 0 : Math.max(0, (item?.quantity || 1) + Number(change.dataset.cartDrawerChange))
		const cartLine = (change || remove).closest(".cart-drawer__item")
		const feedbackStartedAt = performance.now()
		cartLine?.classList.add("is-updating")
		cartLine?.querySelectorAll("button").forEach((button) => { button.disabled = true })
		try {
			const response = await fetch("/cart/change.js", { method: "POST", headers: { Accept: "application/json", "Content-Type": "application/json" }, body: JSON.stringify({ id: key, quantity }) })
			if (!response.ok) throw new Error("Cart change failed")
			const cart = await response.json()
			const remainingFeedbackTime = Math.max(0, 320 - (performance.now() - feedbackStartedAt))
			if (remainingFeedbackTime) await new Promise((resolve) => window.setTimeout(resolve, remainingFeedbackTime))
			updateCartCount(cart); renderCartDrawer(cart)
		} catch (error) {
			const remainingFeedbackTime = Math.max(0, 320 - (performance.now() - feedbackStartedAt))
			if (remainingFeedbackTime) await new Promise((resolve) => window.setTimeout(resolve, remainingFeedbackTime))
			if (change && Number(change.dataset.cartDrawerChange) > 0) {
				change.disabled = true
			}
			cartLine?.classList.remove("is-updating")
			cartLine?.querySelectorAll("button").forEach((button) => { button.disabled = false })
		}
	})

	cartDrawer?.addEventListener("change", async (event) => {
		const input = event.target.closest("[data-cart-drawer-input]")
		if (!input) return
		const quantity = Math.max(0, Number.parseInt(input.value || "1", 10) || 1)
		try { const response = await fetch("/cart/change.js", { method: "POST", headers: { Accept: "application/json", "Content-Type": "application/json" }, body: JSON.stringify({ id: input.dataset.cartLineKey, quantity }) }); if (!response.ok) throw new Error(); const cart = await response.json(); updateCartCount(cart); renderCartDrawer(cart) } catch (error) {}
	})

	document.addEventListener("keydown", (event) => { if (event.key === "Escape" && !cartDrawer?.hidden) closeCartDrawer() })

	document.querySelectorAll("[data-continue-shopping]").forEach((button) => {
		button.addEventListener("click", () => {
			if (window.history.length > 1) {
				window.history.back()
				return
			}
			window.location.href = button.dataset.fallbackUrl || "/collections"
		})
	})

	const flashButton = (button) => {
		if (!button) {
			return
		}

		button.classList.add("is-pressed")
		window.setTimeout(() => {
			button.classList.remove("is-pressed")
		}, 180)
	}

	const initializeProductTileForm = (form) => {
		if (form.dataset.productTileInitialized === "true") {
			return
		}

		const variantInput = form.querySelector('input[name="id"]')
		const submitButton = form.querySelector("[data-product-tile-submit]")
		const quantityWrap = form.querySelector("[data-product-tile-quantity]")
		const quantityValue = form.querySelector("[data-cart-quantity-value]")
		const decrementButton = form.querySelector("[data-cart-decrement]")
		const incrementButton = form.querySelector("[data-cart-increment]")
		const inventoryLimitedInput = form.querySelector("[data-inventory-limited]")
		const maxQuantityInput = form.querySelector("[data-max-quantity]")

		if (!variantInput || !submitButton || !quantityWrap || !quantityValue) {
			return
		}

		form.dataset.productTileInitialized = "true"
		const defaultSubmitLabel = submitButton.textContent

		const setQuantityState = (quantity) => {
			if (quantity > 0) {
				quantityValue.textContent = quantity
				quantityWrap.hidden = false
				submitButton.hidden = true
			} else {
				quantityWrap.hidden = true
				submitButton.hidden = false
				submitButton.textContent = defaultSubmitLabel
			}
		}

		submitButton.hidden = false
		quantityWrap.hidden = true

		const getMaxQuantity = () => {
			if (!inventoryLimitedInput || inventoryLimitedInput.value !== "true") {
				return null
			}

			const parsedMax = Number.parseInt(maxQuantityInput?.value || "", 10)
			return Number.isNaN(parsedMax) ? null : parsedMax
		}

		const setBusy = (isBusy) => {
			const currentQuantity = Number.parseInt(
				quantityValue.textContent || "0",
				10
			)
			const currentMax = getMaxQuantity()
			const isMaxed = currentMax !== null && currentQuantity >= currentMax

			submitButton.disabled = isBusy || (currentMax !== null && currentMax <= 0)
			quantityValue.classList.toggle(
				"is-loading",
				isBusy && !quantityWrap.hidden
			)

			if (decrementButton) {
				decrementButton.disabled = isBusy || currentQuantity <= 0
			}

			if (incrementButton) {
				incrementButton.disabled =
					isBusy || (currentMax !== null && currentQuantity >= currentMax)
				incrementButton.classList.toggle("is-maxed", isMaxed)
			}
		}

		const syncFromCart = async () => {
			const cart = await fetchCart()
			const item = findCartItemByVariant(cart, variantInput.value)
			updateCartCount(cart)
			setQuantityState(item ? item.quantity : 0)
			return cart
		}

		form.addEventListener("submit", async (event) => {
			event.preventDefault()

			const currentMax = getMaxQuantity()
			if (currentMax !== null) {
				const cart = await fetchCart().catch(() => null)

				if (cart) {
					const remainingInventory = getRemainingInventory(
						cart,
						variantInput.value,
						currentMax
					)

					if (remainingInventory !== null && remainingInventory <= 0) {
						await syncFromCart().catch(() => {})
						setBusy(false)
						return
					}
				}
			}

			submitButton.textContent = "Adding..."
			submitButton.classList.add("is-loading")
			setBusy(true)

			try {
				const response = await fetch("/cart/add.js", {
					method: "POST",
					headers: {
						Accept: "application/json",
					},
					body: new FormData(form),
				})

				if (!response.ok) {
					throw new Error("Add to cart failed")
				}

				await syncFromCart()
				openCartDrawer(submitButton)
			} catch (error) {
				submitButton.classList.remove("is-loading")
				submitButton.textContent = "Try again"
				window.setTimeout(() => {
					submitButton.textContent = defaultSubmitLabel
				}, 1200)
			} finally {
				submitButton.classList.remove("is-loading")
				setBusy(false)
			}
		})

		incrementButton?.addEventListener("click", async () => {
			const currentMax = getMaxQuantity()

			flashButton(incrementButton)
			setBusy(true)

			try {
				if (currentMax !== null) {
					const cart = await fetchCart()
					const remainingInventory = getRemainingInventory(
						cart,
						variantInput.value,
						currentMax
					)

					if (remainingInventory !== null && remainingInventory <= 0) {
						await syncFromCart().catch(() => {})
						return
					}
				}

				const formData = new FormData()
				formData.append("id", variantInput.value)
				formData.append("quantity", "1")

				const response = await fetch("/cart/add.js", {
					method: "POST",
					headers: {
						Accept: "application/json",
					},
					body: formData,
				})

				if (!response.ok) {
					throw new Error("Increment failed")
				}

				await syncFromCart()
				openCartDrawer(incrementButton)
			} finally {
				setBusy(false)
			}
		})

		decrementButton?.addEventListener("click", async () => {
			flashButton(decrementButton)
			setBusy(true)

			try {
				const cart = await fetchCart()
				const item = findCartItemByVariant(cart, variantInput.value)

				if (!item) {
					setQuantityState(0)
					return
				}

				const response = await fetch("/cart/change.js", {
					method: "POST",
					headers: {
						Accept: "application/json",
						"Content-Type": "application/json",
					},
					body: JSON.stringify({
						id: item.key,
						quantity: Math.max(item.quantity - 1, 0),
					}),
				})

				if (!response.ok) {
					throw new Error("Decrement failed")
				}

				const updatedCart = await response.json()
				updateCartCount(updatedCart)
				const updatedItem = findCartItemByVariant(
					updatedCart,
					variantInput.value
				)
				setQuantityState(updatedItem ? updatedItem.quantity : 0)
			} finally {
				setBusy(false)
			}
		})

		window.addEventListener("cart:updated", (event) => {
			const item = findCartItemByVariant(event.detail.cart, variantInput.value)
			setQuantityState(item ? item.quantity : 0)
		})

		const hydrateQuantityFromCart = (cart) => {
			const item = findCartItemByVariant(cart, variantInput.value)
			setQuantityState(item ? item.quantity : 0)
		}

		if (cartDrawerCart) {
			hydrateQuantityFromCart(cartDrawerCart)
		} else {
			fetchCart().then(hydrateQuantityFromCart).catch(() => {})
		}

		// fetchCart shares an in-flight request across every tile; cart:updated keeps
		// each control synchronized after subsequent drawer and quantity changes.
	}

	document.querySelectorAll(".product-tile__form").forEach(initializeProductTileForm)

	document.querySelectorAll("[data-product-form]").forEach((form) => {
		const productRoot = form.closest(".main-product") || form.parentElement
		const productForm = form.querySelector("form")
		const variantInput = form.querySelector("[data-variant-id]")
		const buyWrap = form.querySelector("[data-product-pdp-buy]")
		const quantityInputWrap = form.querySelector("[data-product-pdp-quantity]")
		const quantityInput = form.querySelector('input[name="quantity"]')
		const inventoryLimitedInput = form.querySelector("[data-inventory-limited]")
		const maxQuantityInput = form.querySelector("[data-max-quantity]")
		const optionGroups = form.querySelectorAll(".main-product__option")
		const optionInputs = form.querySelectorAll("[data-product-option]")
		const priceElement = productRoot?.querySelector("[data-product-price]")
		const comparePriceElement = productRoot?.querySelector(
			"[data-product-compare-price]"
		)
		const stockElement = productRoot?.querySelector("[data-product-stock]")
		const submitButton = form.querySelector("[data-product-submit]")
		const expressCheckout = form.querySelector(
			"[data-product-express-checkout]"
		)
		const quantityWrap = form.querySelector("[data-product-pdp-cart-quantity]")
		const quantityValue = form.querySelector("[data-cart-quantity-value]")
		const decrementButton = form.querySelector("[data-cart-decrement]")
		const incrementButton = form.querySelector("[data-cart-increment]")
		const variants = JSON.parse(form.dataset.variants || "[]")
		let isUpdating = false
		let pendingQuantity = null
		let debounceTimer

		if (
			!productForm ||
			!variantInput ||
			!submitButton ||
			!priceElement ||
			!variants.length
		) {
			return
		}

		const currency = Shopify.currency.active || "USD"

		const formatMoney = (cents) => {
			return new Intl.NumberFormat("en-US", {
				style: "currency",
				currency,
			}).format(Number(cents || 0) / 100)
		}

		const findSelectedVariant = () => {
			const currentVariant =
				variants.find(
					(variant) => String(variant.id) === String(variantInput.value)
				) ||
				variants[0] ||
				null

			if (!optionGroups.length) {
				return currentVariant
			}

			const selectedOptions = Array.from(optionGroups).map((group) => {
				const checkedRadio = group.querySelector(
					'input[type="radio"][data-product-option]:checked'
				)
				if (checkedRadio) {
					return checkedRadio.value
				}

				const select = group.querySelector("select[data-product-option]")
				return select ? select.value : ""
			})

			return (
				variants.find((variant) => {
					if (!Array.isArray(variant.options)) {
						return false
					}

					return variant.options.every(
						(option, index) => option === selectedOptions[index]
					)
				}) || currentVariant
			)
		}

		const updatePricing = (variant) => {
			const hasSale =
				Boolean(variant.compare_at_price) &&
				Number(variant.compare_at_price) > Number(variant.price)

			if (comparePriceElement) {
				if (hasSale) {
					comparePriceElement.textContent = formatMoney(
						variant.compare_at_price
					)
					comparePriceElement.hidden = false
				} else {
					comparePriceElement.textContent = ""
					comparePriceElement.hidden = true
				}
			}

			priceElement.textContent = formatMoney(variant.price)
			priceElement.classList.toggle("main-product__price--sale", hasSale)
		}

		const updateStock = (variant) => {
			if (!stockElement) {
				return
			}

			const inventoryLimited =
				Boolean(variant.inventory_management) &&
				variant.inventory_policy === "deny"
			const stockCount = Number.parseInt(variant.inventory_quantity, 10)
			const lowStock =
				Boolean(variant.available) &&
				inventoryLimited &&
				!Number.isNaN(stockCount) &&
				stockCount < 5

			stockElement.classList.toggle("main-product__stock--low", lowStock)

			if (lowStock) {
				stockElement.textContent = `Only ${stockCount} left`
				stockElement.hidden = false
			} else {
				stockElement.textContent = ""
				stockElement.hidden = true
			}
		}

		const syncOptionBoxes = () => {
			optionGroups.forEach((group) => {
				group.querySelectorAll(".main-product__option-box").forEach((label) => {
					const radio = label.querySelector(
						'input[type="radio"][data-product-option]'
					)
					label.classList.toggle("is-selected", Boolean(radio?.checked))
				})
			})
		}

		const setQuantityState = (quantity) => {
			const hasQuantity = quantity > 0

			if (quantityValue) {
				quantityValue.value = String(quantity || 0)
			}

			if (quantityInput) {
				quantityInput.value = String(Math.max(quantity || 1, 1))
			}

			if (buyWrap) {
				buyWrap.hidden = hasQuantity
			}

			if (quantityWrap) {
				quantityWrap.hidden = !hasQuantity
			}

			if (quantityInputWrap) {
				quantityInputWrap.hidden = hasQuantity
			}

			if (submitButton) {
				submitButton.hidden = hasQuantity
				if (!hasQuantity) {
					submitButton.disabled = false
					submitButton.textContent = "Add to cart"
					submitButton.classList.remove("is-maxed")
				}
			}
		}

		const updateExpressCheckout = (variant) => {
			if (!expressCheckout) {
				return
			}

			expressCheckout.hidden = !variant.available
		}

		const syncQuantityField = (variant) => {
			if (!quantityInput) {
				return
			}

			const inventoryLimited =
				Boolean(variant.inventory_management) &&
				variant.inventory_policy === "deny"
			const maxQuantity = Number.parseInt(variant.inventory_quantity, 10)

			if (inventoryLimitedInput) {
				inventoryLimitedInput.value = inventoryLimited ? "true" : "false"
			}

			if (maxQuantityInput) {
				maxQuantityInput.value = Number.isNaN(maxQuantity)
					? ""
					: String(maxQuantity)
			}

			if (inventoryLimited && !Number.isNaN(maxQuantity)) {
				quantityInput.max = String(Math.max(maxQuantity, 1))
				quantityInput.dataset.maxQuantity = String(Math.max(maxQuantity, 1))
				if (Number.parseInt(quantityInput.value || "1", 10) > maxQuantity) {
					quantityInput.value = String(Math.max(maxQuantity, 1))
				}
			} else {
				quantityInput.removeAttribute("max")
				delete quantityInput.dataset.maxQuantity
			}
		}

		const updateQuantityStepperState = (variant, cart) => {
			const inventoryLimited =
				Boolean(variant.inventory_management) &&
				variant.inventory_policy === "deny"
			const maxQuantity = Number.parseInt(variant.inventory_quantity, 10)
			const currentItem = cart ? findCartItemByVariant(cart, variant.id) : null
			const currentInCart = currentItem ? currentItem.quantity : 0
			const remainingInventory =
				inventoryLimited && !Number.isNaN(maxQuantity)
					? Math.max(maxQuantity - currentInCart, 0)
					: null
			const hasQuantity = currentInCart > 0

			setQuantityState(currentInCart)

			if (quantityValue) {
				if (inventoryLimited && !Number.isNaN(maxQuantity)) {
					quantityValue.max = String(Math.max(maxQuantity, 0))
					quantityValue.min = "0"
				} else {
					quantityValue.removeAttribute("max")
				}
			}

			if (quantityValue) {
				quantityValue.disabled = isUpdating
			}

			if (decrementButton) {
				decrementButton.disabled = isUpdating || currentInCart <= 0
			}

			if (incrementButton) {
				incrementButton.disabled =
					isUpdating ||
					!variant.available ||
					(remainingInventory !== null && remainingInventory <= 0)
				incrementButton.classList.toggle(
					"is-maxed",
					remainingInventory !== null && remainingInventory <= 0
				)
			}

			if (!variant.available) {
				submitButton.disabled = true
				submitButton.textContent = "Sold out"
				submitButton.classList.remove("is-maxed", "is-loading")
				return
			}

			if (hasQuantity) {
				submitButton.hidden = true
				submitButton.disabled = false
				submitButton.classList.remove("is-loading")
				return
			}

			if (remainingInventory !== null && remainingInventory <= 0) {
				submitButton.disabled = true
				submitButton.textContent = "Max quantity added"
				submitButton.classList.add("is-maxed")
				submitButton.classList.remove("is-loading")
				return
			}

			submitButton.disabled = false
			submitButton.textContent = "Add to cart"
			submitButton.classList.remove("is-maxed", "is-loading")
		}

		const getMaxQuantity = () => {
			if (!inventoryLimitedInput || inventoryLimitedInput.value !== "true") {
				return null
			}

			const parsedMax = Number.parseInt(
				quantityValue?.max || maxQuantityInput?.value || "",
				10
			)
			return Number.isNaN(parsedMax) ? null : parsedMax
		}

		const clampQuantity = (allowZero = false) => {
			if (!quantityValue) {
				return 0
			}

			const parsedValue = Number.parseInt(quantityValue.value || "0", 10)
			let nextValue = Number.isNaN(parsedValue)
				? allowZero
					? 0
					: 1
				: parsedValue
			const minimumQuantity = allowZero ? 0 : 1
			const currentMax = getMaxQuantity()

			if (nextValue < minimumQuantity) {
				nextValue = minimumQuantity
			}

			if (currentMax !== null) {
				nextValue = Math.min(nextValue, currentMax)
			}

			quantityValue.value = String(nextValue)

			if (decrementButton) {
				decrementButton.disabled = isUpdating || nextValue <= 0
			}

			if (incrementButton) {
				incrementButton.disabled =
					isUpdating || (currentMax !== null && nextValue >= currentMax)
				incrementButton.classList.toggle(
					"is-maxed",
					currentMax !== null && nextValue >= currentMax
				)
			}

			return nextValue
		}

		const setLoadingState = (loading) => {
			quantityWrap?.classList.toggle("is-loading", loading)
			quantityValue?.classList.toggle("is-loading", loading)
			if (quantityValue) {
				quantityValue.disabled = loading
			}

			if (decrementButton) {
				decrementButton.disabled =
					loading || Number.parseInt(quantityValue?.value || "0", 10) <= 0
			}

			if (incrementButton) {
				const currentMax = getMaxQuantity()
				const currentValue = Number.parseInt(quantityValue?.value || "0", 10)
				incrementButton.disabled =
					loading || (currentMax !== null && currentValue >= currentMax)
			}
		}

		const submitQuantityChange = (allowZero = false) => {
			return (async () => {
				if (isUpdating) {
					pendingQuantity = clampQuantity(allowZero)
					return
				}

				const nextQuantity = clampQuantity(allowZero)
				const currentVariant = findSelectedVariant()

				if (!currentVariant) {
					return
				}

				isUpdating = true
				setLoadingState(true)

				try {
					const cart = await fetchCart()
					const item = findCartItemByVariant(cart, currentVariant.id)

					if (!item) {
						if (nextQuantity > 0) {
							const addResponse = await fetch("/cart/add.js", {
								method: "POST",
								headers: {
									Accept: "application/json",
									"Content-Type": "application/json",
								},
								body: JSON.stringify({
									id: currentVariant.id,
									quantity: nextQuantity,
								}),
							})

							if (!addResponse.ok) {
								throw new Error("Cart add failed")
							}

							const addedCart = await fetchCart()
							updateCartCount(addedCart)
							updateQuantityStepperState(currentVariant, addedCart)
							updateStock(currentVariant)
							openCartDrawer(submitButton)
							return
						}

						setQuantityState(0)
						return
					}

					const response = await fetch("/cart/change.js", {
						method: "POST",
						headers: {
							Accept: "application/json",
							"Content-Type": "application/json",
						},
						body: JSON.stringify({
							id: item.key,
							quantity: nextQuantity,
						}),
					})

					if (!response.ok) {
						throw new Error("Cart change failed")
					}

					const updatedCart = await response.json()
					updateCartCount(updatedCart)
					updateQuantityStepperState(currentVariant, updatedCart)
					updateStock(currentVariant)
				} catch (error) {
					const cart = await fetchCart().catch(() => null)
					updateQuantityStepperState(currentVariant, cart)
					updateStock(currentVariant)
				} finally {
					isUpdating = false
					setLoadingState(false)

					if (pendingQuantity !== null) {
						const queuedQuantity = pendingQuantity
						pendingQuantity = null
						if (quantityValue) {
							quantityValue.value = String(queuedQuantity)
						}
						submitQuantityChange(queuedQuantity === 0)
					}
				}
			})()
		}

		const refreshVariantState = async () => {
			const variant = findSelectedVariant()

			if (!variant) {
				return null
			}

			variantInput.value = variant.id
			syncQuantityField(variant)
			updatePricing(variant)
			updateStock(variant)
			updateExpressCheckout(variant)
			syncOptionBoxes()
			updateQuantityStepperState(variant, null)

			const cart = await fetchCart().catch(() => null)
			updateQuantityStepperState(variant, cart)

			return variant
		}

		optionInputs.forEach((input) =>
			input.addEventListener("change", () => {
				syncOptionBoxes()
				refreshVariantState().catch(() => {})
			})
		)

		productForm.addEventListener("submit", async (event) => {
			event.preventDefault()

			const variant = findSelectedVariant()

			if (!variant) {
				return
			}

			const cart = await fetchCart().catch(() => null)
			const currentItem = cart ? findCartItemByVariant(cart, variant.id) : null
			const currentInCart = currentItem ? currentItem.quantity : 0
			const inventoryLimited =
				Boolean(variant.inventory_management) &&
				variant.inventory_policy === "deny"
			const maxQuantity = Number.parseInt(variant.inventory_quantity, 10)
			const requestedQuantity = Number.parseInt(quantityInput?.value || "1", 10)
			const remainingInventory =
				inventoryLimited && !Number.isNaN(maxQuantity)
					? Math.max(maxQuantity - currentInCart, 0)
					: null

			if (remainingInventory !== null && remainingInventory <= 0) {
				updateQuantityStepperState(variant, cart)
				return
			}

			if (
				remainingInventory !== null &&
				requestedQuantity > remainingInventory
			) {
				if (quantityInput) {
					quantityInput.value = String(remainingInventory)
				}
				return
			}

			submitButton.disabled = true
			submitButton.textContent = "Adding..."
			submitButton.classList.add("is-loading")

			try {
				const response = await fetch("/cart/add.js", {
					method: "POST",
					headers: {
						Accept: "application/json",
					},
					body: new FormData(productForm),
				})

				if (!response.ok) {
					throw new Error("Add to cart failed")
				}

				await response.json()
				const updatedCart = await fetchCart()
				updateCartCount(updatedCart)
				updateQuantityStepperState(variant, updatedCart)
				updateStock(variant)
			} catch (error) {
				updateQuantityStepperState(variant, cart)
				updateStock(variant)
			} finally {
				submitButton.classList.remove("is-loading")
			}
		})

		decrementButton?.addEventListener("click", async () => {
			flashButton(decrementButton)
			const currentValue = Number.parseInt(quantityValue?.value || "0", 10)
			if (quantityValue) {
				quantityValue.value = String(Math.max(currentValue - 1, 0))
			}
			window.clearTimeout(debounceTimer)
			submitQuantityChange(true)
		})

		incrementButton?.addEventListener("click", async () => {
			flashButton(incrementButton)
			const currentMax = getMaxQuantity()
			const currentValue = Number.parseInt(quantityValue?.value || "0", 10)

			if (quantityValue) {
				quantityValue.value = String(currentValue + 1)
			}

			if (
				currentMax !== null &&
				Number.parseInt(quantityValue?.value || "0", 10) > currentMax
			) {
				if (quantityValue) {
					quantityValue.value = String(currentMax)
				}
				const cart = await fetchCart().catch(() => null)
				const currentVariant = findSelectedVariant()
				if (currentVariant) {
					updateQuantityStepperState(currentVariant, cart)
					updateStock(currentVariant)
				}
				return
			}

			window.clearTimeout(debounceTimer)
			submitQuantityChange()
		})

		quantityValue?.addEventListener("change", () => {
			clampQuantity()
		})

		quantityValue?.addEventListener("blur", () => {
			window.clearTimeout(debounceTimer)
			submitQuantityChange(quantityValue?.value === "0")
		})

		quantityValue?.addEventListener("keydown", (event) => {
			if (event.key === "Enter") {
				event.preventDefault()
				window.clearTimeout(debounceTimer)
				submitQuantityChange(quantityValue?.value === "0")
			}
		})

		window.addEventListener("cart:updated", (event) => {
			const currentVariant = findSelectedVariant()
			if (currentVariant) {
				updateQuantityStepperState(currentVariant, event.detail.cart)
			}
		})

		refreshVariantState().catch(() => {})
	})

	document.querySelectorAll(".cart-form").forEach((form) => {
		const quantityInputs = form.querySelectorAll("[data-cart-quantity-input]")
		const cartSummary = form.querySelector("[data-cart-summary]")
		const cartTable = form.querySelector(".cart-table")

		const updateMoneyText = (element, cents) => {
			if (!element) {
				return
			}

			const value = Number(cents || 0) / 100
			element.textContent = new Intl.NumberFormat("en-US", {
				style: "currency",
				currency: Shopify.currency.active || "USD",
			}).format(value)
		}

		const updateCartSummary = (cart) => {
			if (!cartSummary) return
			const freeShippingThreshold = Number(cartSummary.dataset.freeShippingThreshold || 0)
			const flatShippingRate = Number(cartSummary.dataset.flatShippingRate || 0)
			const amountRemaining = Math.max(freeShippingThreshold - cart.total_price, 0)
			const shippingCost = amountRemaining ? flatShippingRate : 0
			updateMoneyText(cartSummary.querySelector("[data-cart-subtotal]"), cart.total_price)
			const shippingElement = cartSummary.querySelector("[data-cart-shipping]")
			if (shippingElement) shippingElement.textContent = shippingCost ? new Intl.NumberFormat("en-US", { style: "currency", currency: Shopify.currency.active || "USD" }).format(shippingCost / 100) : "Free"
			updateMoneyText(cartSummary.querySelector("[data-cart-grand-total]"), cart.total_price + shippingCost)
			const progress = freeShippingThreshold ? Math.min((cart.total_price / freeShippingThreshold) * 100, 100) : 100
			const status = cartSummary.querySelector("[data-cart-free-shipping-status]")
			const copy = cartSummary.querySelector("[data-cart-free-shipping-copy]")
			const progressBar = cartSummary.querySelector("[data-cart-free-shipping-progress]")
			if (status) status.textContent = amountRemaining ? `${new Intl.NumberFormat("en-US", { style: "currency", currency: Shopify.currency.active || "USD" }).format(amountRemaining / 100)} away` : "Unlocked"
			if (copy) copy.textContent = amountRemaining ? `Add ${new Intl.NumberFormat("en-US", { style: "currency", currency: Shopify.currency.active || "USD" }).format(amountRemaining / 100)} more for free shipping.` : "Your order qualifies for free shipping."
			if (progressBar) progressBar.style.width = `${progress}%`
		}

		quantityInputs.forEach((input) => {
			let debounceTimer
			let isUpdating = false
			let pendingQuantity = null
			const quantityControl = input.parentElement
			const cartLine = input.closest(".cart-line")
			const decrementButton = input.parentElement?.querySelector(
				"[data-cart-decrement]"
			)
			const incrementButton = input.parentElement?.querySelector(
				"[data-cart-increment]"
			)

			const clampQuantity = (allowZero = false) => {
				const inventoryLimited = input.dataset.inventoryLimited === "true"
				const maxQuantity = Number.parseInt(input.dataset.maxQuantity || "", 10)
				const parsedValue = Number.parseInt(input.value || "0", 10)
				let nextValue = Number.isNaN(parsedValue)
					? allowZero
						? 0
						: 1
					: parsedValue
				const minimumQuantity = allowZero ? 0 : 1

				if (nextValue < minimumQuantity) {
					nextValue = minimumQuantity
				}

				if (inventoryLimited && !Number.isNaN(maxQuantity)) {
					nextValue = Math.min(nextValue, maxQuantity)
				}

				input.value = String(nextValue)

				if (decrementButton) {
					decrementButton.disabled = nextValue <= 0
				}

				if (incrementButton) {
					incrementButton.disabled =
						inventoryLimited &&
						!Number.isNaN(maxQuantity) &&
						nextValue >= maxQuantity
				}

				return nextValue
			}

			const setLoadingState = (loading) => {
				quantityControl?.classList.toggle("is-loading", loading)
				input.classList.toggle("is-loading", loading)
				input.disabled = loading

				if (decrementButton) {
					decrementButton.disabled =
						loading || Number.parseInt(input.value || "0", 10) <= 0
				}

				if (incrementButton) {
					const inventoryLimited = input.dataset.inventoryLimited === "true"
					const maxQuantity = Number.parseInt(
						input.dataset.maxQuantity || "",
						10
					)
					const currentValue = Number.parseInt(input.value || "1", 10)
					incrementButton.disabled =
						loading ||
						(inventoryLimited &&
							!Number.isNaN(maxQuantity) &&
							currentValue >= maxQuantity)
				}
			}

			const submitQuantityChange = (allowZero = false) => {
				return (async () => {
					if (isUpdating) {
						pendingQuantity = clampQuantity(allowZero)
						return
					}

					const nextQuantity = clampQuantity(allowZero)
					isUpdating = true
					setLoadingState(true)

					try {
						const response = await fetch("/cart/change.js", {
							method: "POST",
							headers: {
								Accept: "application/json",
								"Content-Type": "application/json",
							},
							body: JSON.stringify({
								id: input.dataset.lineKey,
								quantity: nextQuantity,
							}),
						})

						if (!response.ok) {
							throw new Error("Cart change failed")
						}

						const cart = await response.json()
						updateCartCount(cart)

						const lineItem =
							cart.items.find((item) => item.key === input.dataset.lineKey) ||
							null
						const linePrice = input
							.closest(".cart-line__controls")
							?.querySelector("[data-cart-line-price]")

						if (lineItem) {
							input.value = String(lineItem.quantity)
							updateMoneyText(linePrice, lineItem.final_line_price)
						}

						updateCartSummary(cart)

						if (nextQuantity === 0 || !lineItem) {
							cartLine?.remove()

							if (!cartTable?.querySelector(".cart-line")) {
								window.location.reload()
							}

							return
						}
					} catch (error) {
						clampQuantity()
					} finally {
						isUpdating = false
						setLoadingState(false)

						if (pendingQuantity !== null) {
							const queuedQuantity = pendingQuantity
							pendingQuantity = null
							input.value = String(queuedQuantity)
							submitQuantityChange(queuedQuantity === 0)
						}
					}
				})()
			}

			input.addEventListener("change", () => {
				clampQuantity()
				window.clearTimeout(debounceTimer)
				submitQuantityChange()
			})

			decrementButton?.addEventListener("click", () => {
				const currentValue = Number.parseInt(input.value || "1", 10)
				input.value = String(Math.max(currentValue - 1, 0))
				clampQuantity(true)
				window.clearTimeout(debounceTimer)
				submitQuantityChange(true)
			})

			incrementButton?.addEventListener("click", () => {
				const currentValue = Number.parseInt(input.value || "1", 10)
				input.value = String(currentValue + 1)
				clampQuantity()
				window.clearTimeout(debounceTimer)
				submitQuantityChange()
			})

			clampQuantity()
		})

		form.querySelectorAll(".cart-line__remove").forEach((removeLink) => {
			removeLink.addEventListener("click", async (event) => {
				event.preventDefault()

				const cartLine = removeLink.closest(".cart-line")
				const quantityInput = cartLine?.querySelector(
					"[data-cart-quantity-input]"
				)

				if (!cartLine || !quantityInput) {
					return
				}

				quantityInput.disabled = true
				cartLine.style.pointerEvents = "none"
				cartLine.style.opacity = "0.55"

				try {
					const response = await fetch("/cart/change.js", {
						method: "POST",
						headers: {
							Accept: "application/json",
							"Content-Type": "application/json",
						},
						body: JSON.stringify({
							id: quantityInput.dataset.lineKey,
							quantity: 0,
						}),
					})

					if (!response.ok) {
						throw new Error("Cart remove failed")
					}

					const cart = await response.json()
					updateCartCount(cart)
					updateCartSummary(cart)
					cartLine.remove()

					if (!cartTable?.querySelector(".cart-line")) {
						window.location.reload()
					}
				} catch (error) {
					quantityInput.disabled = false
					cartLine.style.pointerEvents = ""
					cartLine.style.opacity = ""
				}
			})
		})
	})

	fetchCart()
		.then((cart) => updateCartCount(cart))
		.catch(() => {})

	document.querySelectorAll("[data-predictive-search]").forEach((form) => {
		const input = form.querySelector("[data-predictive-search-input]")
		const results = form.querySelector("[data-predictive-search-results]")

		if (!input || !results) {
			return
		}

		let debounceTimer
		let activeController

		const closeResults = () => {
			results.hidden = true
			results.innerHTML = ""
		}

		const renderResults = (query, products) => {
			if (!products.length) {
				results.innerHTML =
					'<p class="header-search__empty">No products found.</p>'
				results.hidden = false
				return
			}

			const items = products
				.map((product) => {
					const imageMarkup = product.featured_image?.url
						? `<img src="${
								product.featured_image.url
						  }&width=180" alt="${product.title.replace(/"/g, "&quot;")}">`
						: '<div class="header-search__result-placeholder"></div>'

					const price = product.price ? product.price : ""

					return `
          <a class="header-search__result" href="${product.url}">
            <div class="header-search__result-media">${imageMarkup}</div>
            <div>
              <p class="header-search__result-title">${product.title}</p>
              <p class="header-search__result-price">${price}</p>
            </div>
          </a>
        `
				})
				.join("")

			results.innerHTML = `
        ${items}
        <a class="button button--ghost header-search__all" href="/search?q=${encodeURIComponent(
					query
				)}&type=product">View all results</a>
      `
			applyProductImageBackgrounds(results)
			results.hidden = false
		}

		input.addEventListener("input", () => {
			const query = input.value.trim()

			clearTimeout(debounceTimer)

			if (activeController) {
				activeController.abort()
			}

			if (query.length < 2) {
				closeResults()
				return
			}

			debounceTimer = window.setTimeout(async () => {
				activeController = new AbortController()

				try {
					const response = await fetch(
						`/search/suggest.json?q=${encodeURIComponent(
							query
						)}&resources[type]=product&resources[limit]=6`,
						{ signal: activeController.signal }
					)

					if (!response.ok) {
						closeResults()
						return
					}

					const data = await response.json()
					const products = data?.resources?.results?.products || []
					renderResults(query, products)
				} catch (error) {
					if (error.name !== "AbortError") {
						closeResults()
					}
				}
			}, 180)
		})

		input.addEventListener("focus", () => {
			if (results.innerHTML.trim() !== "") {
				results.hidden = false
			}
		})

		document.addEventListener("click", (event) => {
			if (!form.contains(event.target)) {
				closeResults()
			}
		})

		input.form?.addEventListener("submit", () => {
			closeResults()
		})
	})

	document.querySelectorAll("[data-stock-filter-root]").forEach((root) => {
		const toggle = root.querySelector("[data-in-stock-toggle]")
		const availabilityFilterParam = "filter.v.availability"
		const filtersToggle = root.querySelector("[data-filters-toggle]")
		const filtersPanel = root.querySelector("[data-filters-panel]")
		const filtersCloseButtons = Array.from(root.querySelectorAll("[data-filters-close]"))
		const filtersBackdrop = root.querySelector("[data-filters-backdrop]")
		const clearFiltersButtons = Array.from(root.querySelectorAll("[data-clear-filters]"))
		const filterCountBadges = Array.from(root.querySelectorAll("[data-filter-count]"))
		let cards = Array.from(root.querySelectorAll("[data-product-card]"))
		const productGrid = root.querySelector("[data-product-grid]")
		const pagination = root.querySelector(".pagination")
		const sourcePageCount = Number(productGrid?.dataset.sourcePageCount || "1")
		const sourceCurrentPage = Number(productGrid?.dataset.sourceCurrentPage || "1")
		const sectionId = root.dataset.sectionId || "main"
		const emptyState = root.querySelector("[data-stock-filter-empty]")
		const collectionButtons = Array.from(
			root.querySelectorAll("[data-collection-filter-button]")
		)
		const collectionParamInputs = Array.from(
			root.querySelectorAll("[data-collection-filter-param]")
		)
		const metafieldParamInputs = Array.from(
			root.querySelectorAll("[data-metafield-filter-param]")
		)
		const sortSelects = Array.from(root.querySelectorAll("[data-collection-sort]"))
		const metafieldGroups = Array.from(
			root.querySelectorAll("[data-metafield-filter-group]")
		).map((group) => {
			const key = group.dataset.metafieldFilterKey || ""
			const paramName = group.dataset.metafieldFilterParamName || `mf_${key}`
			const buttons = Array.from(
				group.querySelectorAll("[data-metafield-filter-button]")
			)
			const values = new Set(
				buttons
					.map((button) => button.dataset.metafieldFilterValue || "")
					.filter((value) => value && value !== "all")
			)

			return {
				key,
				paramName,
				buttons,
				values,
				inputs: metafieldParamInputs.filter(
					(input) => input.dataset.metafieldFilterKey === key
				),
			}
		})

		if (!toggle || !cards.length) {
			return
		}

		const collectionFilterParam = "collection"
		const collectionGroup = {
			key: "collection",
			paramName: collectionFilterParam,
			buttons: collectionButtons,
			values: new Set(
				collectionButtons
					.map((button) => button.dataset.collectionFilterValue || "")
					.filter((value) => value && value !== "all")
			),
			inputs: collectionParamInputs,
		}

		const filterGroups = [collectionGroup, ...metafieldGroups]
		const desktopFiltersQuery = window.matchMedia("(min-width: 900px)")
		const initialUrl = new URL(window.location.href)
		const initialAvailabilityFilter = initialUrl.searchParams.get(availabilityFilterParam)
		const collectionFilterValues = collectionGroup.values
		let activeCollectionFilters = new Set()
		const activeMetafieldFilters = new Map(
			metafieldGroups.map((group) => [group.key, new Set()])
		)
		let isFiltersPanelOpen = false
		let filtersDrawerCloseTimer
		let allListingPagesPromise

		const loadAllListingPages = () => {
			if (!productGrid || sourcePageCount <= 1 || allListingPagesPromise) {
				return allListingPagesPromise || Promise.resolve()
			}
			if (pagination) {
				pagination.hidden = true
			}

			allListingPagesPromise = Promise.all(
				Array.from({ length: sourcePageCount }, (_, index) => index + 1)
					.filter((page) => page !== sourceCurrentPage)
					.map(
						async (page) => {
						const url = new URL(window.location.href)
						url.searchParams.set("page", String(page))
						url.searchParams.set("section_id", sectionId)

						const response = await fetch(url, { credentials: "same-origin" })
						if (!response.ok) {
							throw new Error(`Unable to load product page ${page}`)
						}

						const pageDocument = new DOMParser().parseFromString(
							await response.text(),
							"text/html"
						)
						const pageCards = Array.from(
							pageDocument.querySelectorAll("[data-product-card]")
						)

						return { page, cards: pageCards }
						}
					)
			).then((loadedPages) => {
				const pages = [
					{ page: sourceCurrentPage, cards },
					...loadedPages,
				].sort((first, second) => first.page - second.page)

				cards = pages.flatMap((listingPage) => listingPage.cards)
				cards.forEach((card) => {
					// These cards are inserted after the page-level reveal observer is
					// initialized, so make them visible as they enter the live grid.
					card.classList.add("is-visible")
					productGrid.append(card)
					card
						.querySelectorAll(".product-tile__form")
						.forEach(initializeProductTileForm)
				})
				pagination?.setAttribute("hidden", "")
			})
				.catch((error) => {
					console.error("Unable to load all products for filtering.", error)
					allListingPagesPromise = undefined
				})

			return allListingPagesPromise
		}

		const normalizeCollectionFilters = (value) => {
			return new Set(
				(value || "")
					.split(",")
					.filter(Boolean)
			)
		}

		const normalizeMetafieldFilters = (group, value) => {
			return new Set(
				(value || "")
					.split(",")
					.filter(Boolean)
			)
		}

		const syncCollectionFilterParamInputs = () => {
			collectionGroup.inputs.forEach((input) => {
				if (!activeCollectionFilters.size) {
					input.disabled = true
					input.value = ""
				} else {
					input.disabled = false
					input.value = [...activeCollectionFilters].join(",")
				}
			})
		}

		const syncMetafieldFilterParamInputs = () => {
			metafieldGroups.forEach((group) => {
				const activeValues = activeMetafieldFilters.get(group.key) || new Set()

				group.inputs.forEach((input) => {
					if (!activeValues.size) {
						input.disabled = true
						input.value = ""
					} else {
						input.disabled = false
						input.value = [...activeValues].join(",")
					}
				})
			})
		}

		const syncCollectionButtons = () => {
			collectionButtons.forEach((button) => {
				const value = button.dataset.collectionFilterValue || "all"
				const isActive = value === "all"
					? !activeCollectionFilters.size
					: activeCollectionFilters.has(value)

				button.classList.toggle("is-active", isActive)
				button.setAttribute("aria-pressed", String(isActive))
			})
		}

		const syncMetafieldButtons = () => {
			metafieldGroups.forEach((group) => {
				const activeValues = activeMetafieldFilters.get(group.key) || new Set()

				group.buttons.forEach((button) => {
					const value = button.dataset.metafieldFilterValue || "all"
					const isActive = value === "all"
						? !activeValues.size
						: activeValues.has(value)

					button.classList.toggle("is-active", isActive)
					button.setAttribute("aria-pressed", String(isActive))
				})
			})
		}

		const getCardCollectionValues = (card) => {
			return (card.dataset.productCollections || "")
				.split(",")
				.filter(Boolean)
		}

		const getCardMetafieldValues = (card, key) => {
			return (card.getAttribute(`data-metafield-${key}`) || "")
				.split(",")
				.filter(Boolean)
		}

		const cardMatchesFilters = (card, excludedGroupKey = null) => {
			const onlyInStock = toggle?.checked ?? true
			const isAvailable = card.dataset.available === "true"

			if (onlyInStock && !isAvailable) {
				return false
			}

			if (activeCollectionFilters.size && excludedGroupKey !== "collection") {
				if (!getCardCollectionValues(card).some((value) => activeCollectionFilters.has(value))) {
					return false
				}
			}

			return metafieldGroups.every((group) => {
				if (group.key === excludedGroupKey) {
					return true
				}

				const activeValues = activeMetafieldFilters.get(group.key) || new Set()
				if (!activeValues.size) {
					return true
				}

				return getCardMetafieldValues(card, group.key).some((value) =>
					activeValues.has(value)
				)
			})
		}

		const computeAvailableValues = (groupKey) => {
			const availableValues = new Set(["all"])

			cards.forEach((card) => {
				if (!cardMatchesFilters(card, groupKey)) {
					return
				}

				if (groupKey === "collection") {
					getCardCollectionValues(card).forEach((value) => {
						availableValues.add(value)
					})
					return
				}

				getCardMetafieldValues(card, groupKey).forEach((value) => {
					availableValues.add(value)
				})
			})

			return availableValues
		}

		const syncGroupAvailability = (group, availableValues) => {
			group.buttons.forEach((button) => {
				const value = button.dataset.collectionFilterValue ||
					button.dataset.metafieldFilterValue ||
					"all"
				const isAvailable = value === "all" || availableValues.has(value)

				button.hidden = false
				button.disabled = !isAvailable
				button.setAttribute("aria-disabled", String(!isAvailable))
			})
		}

		const syncVisibleCards = () => {
			let visibleCount = 0

			cards.forEach((card) => {
				const shouldShow = cardMatchesFilters(card)

				card.hidden = !shouldShow
				if (shouldShow) {
					visibleCount += 1
				}
			})

			if (emptyState) {
				emptyState.hidden = visibleCount !== 0
			}
		}

		const hasActiveFilters = () => {
			if (activeCollectionFilters.size) {
				return true
			}

			return Array.from(activeMetafieldFilters.values()).some(
				(values) => values.size
			)
		}

		const getActiveFilterCount = () => {
			let count = activeCollectionFilters.size

			activeMetafieldFilters.forEach((values) => {
				count += values.size
			})

			return count
		}

		const setFiltersPanelOpen = (isOpen) => {
			if (!filtersPanel) {
				return
			}

			window.clearTimeout(filtersDrawerCloseTimer)
			isFiltersPanelOpen = isOpen
			filtersToggle?.setAttribute("aria-expanded", String(isOpen))
			filtersToggle?.classList.toggle("is-active", isOpen)

			if (desktopFiltersQuery.matches) {
				filtersPanel.classList.remove("is-open")
				filtersPanel.hidden = !isOpen
				filtersBackdrop?.classList.remove("is-visible")
				if (filtersBackdrop) filtersBackdrop.hidden = true
				document.body.classList.remove("filters-drawer-open")
				return
			}

			if (isOpen) {
				filtersPanel.hidden = false
				if (filtersBackdrop) filtersBackdrop.hidden = false
				window.requestAnimationFrame(() => {
					filtersPanel.classList.add("is-open")
					filtersBackdrop?.classList.add("is-visible")
				})
				document.body.classList.add("filters-drawer-open")
				return
			}

			filtersPanel.classList.remove("is-open")
			filtersBackdrop?.classList.remove("is-visible")
			document.body.classList.remove("filters-drawer-open")
			filtersDrawerCloseTimer = window.setTimeout(() => {
				if (!isFiltersPanelOpen) {
					filtersPanel.hidden = true
					if (filtersBackdrop) filtersBackdrop.hidden = true
				}
			}, 240)
		}

		const syncClearFiltersButton = () => {
			if (!clearFiltersButtons.length) {
				return
			}

			const activeCount = getActiveFilterCount()
			filterCountBadges.forEach((badge) => {
				badge.textContent = String(activeCount)
			})
			clearFiltersButtons.forEach((button) => {
				button.disabled = activeCount === 0
				button.setAttribute("aria-label", `Clear ${activeCount} active filters`)
			})
		}

		const clearAllFilters = () => {
			activeCollectionFilters.clear()
			metafieldGroups.forEach((group) => {
				activeMetafieldFilters.get(group.key)?.clear()
			})
			syncAllFilters()
			updateUrlFromFilters()
		}

		const syncDependentFacetAvailability = () => {
			filterGroups.forEach((group) => {
				const availableValues = computeAvailableValues(group.key)
				syncGroupAvailability(group, availableValues)
			})

			return false
		}

		const syncAllFilters = () => {
			const filtersChanged = syncDependentFacetAvailability()
			syncCollectionButtons()
			syncMetafieldButtons()
			syncCollectionFilterParamInputs()
			syncMetafieldFilterParamInputs()
			syncVisibleCards()
			syncClearFiltersButton()

			return filtersChanged
		}

		const syncFiltersFromUrl = () => {
			const url = new URL(window.location.href)
			activeCollectionFilters = normalizeCollectionFilters(
				url.searchParams.get(collectionFilterParam)
			)

			metafieldGroups.forEach((group) => {
				activeMetafieldFilters.set(
					group.key,
					normalizeMetafieldFilters(group, url.searchParams.get(group.paramName))
				)
			})

			const filtersChanged = syncAllFilters()
			if (filtersChanged) {
				updateUrlFromFilters(true)
			}
			if (hasActiveFilters()) {
				if (url.searchParams.has("page")) {
					updateUrlFromFilters(true)
				}
				loadAllListingPages().then(() => syncAllFilters())
			}
		}

		const updateUrlFromFilters = (replaceHistory = false) => {
			const url = new URL(window.location.href)
			// Filtered products are evaluated from the complete rendered listing.
			// Do not retain the page from the unfiltered result set.
			url.searchParams.delete("page")

			if (!activeCollectionFilters.size) {
				url.searchParams.delete(collectionFilterParam)
			} else {
				url.searchParams.set(collectionFilterParam, [...activeCollectionFilters].join(","))
			}

			metafieldGroups.forEach((group) => {
				const activeValues = activeMetafieldFilters.get(group.key) || new Set()

				if (!activeValues.size) {
					url.searchParams.delete(group.paramName)
				} else {
					url.searchParams.set(group.paramName, [...activeValues].join(","))
				}
			})

			if (replaceHistory) {
				window.history.replaceState({}, "", url)
			} else {
				window.history.pushState({}, "", url)
			}
		}

		const setCollectionFilter = (value) => {
			if (value === "all") {
				activeCollectionFilters.clear()
			} else if (activeCollectionFilters.has(value)) {
				activeCollectionFilters.delete(value)
			} else if (collectionFilterValues.has(value)) {
				activeCollectionFilters.add(value)
			}
			const filtersChanged = syncAllFilters()
			updateUrlFromFilters(filtersChanged)
			if (hasActiveFilters()) {
				loadAllListingPages().then(() => syncAllFilters())
			}
		}

		const setMetafieldFilter = (groupKey, value) => {
			const group = metafieldGroups.find((item) => item.key === groupKey)

			if (!group) {
				return
			}

			const activeValues = activeMetafieldFilters.get(group.key) || new Set()

			if (value === "all") {
				activeValues.clear()
			} else if (activeValues.has(value)) {
				activeValues.delete(value)
			} else if (group.values.has(value)) {
				activeValues.add(value)
			}

			activeMetafieldFilters.set(group.key, activeValues)
			const filtersChanged = syncAllFilters()
			updateUrlFromFilters(filtersChanged)
			if (hasActiveFilters()) {
				loadAllListingPages().then(() => syncAllFilters())
			}
		}

		collectionButtons.forEach((button) => {
			button.addEventListener("click", () => {
				setCollectionFilter(button.dataset.collectionFilterValue || "all")
			})
		})

		metafieldGroups.forEach((group) => {
			group.buttons.forEach((button) => {
				button.addEventListener("click", () => {
					setMetafieldFilter(
						group.key,
						button.dataset.metafieldFilterValue || "all"
					)
				})
			})
		})

		sortSelects.forEach((select) => {
			select.addEventListener("change", () => {
				const url = new URL(window.location.href)
				url.searchParams.set("sort_by", select.value)
				url.searchParams.delete("page")
				window.location.assign(url)
			})
		})

		filtersToggle?.addEventListener("click", () => {
			setFiltersPanelOpen(filtersPanel?.hidden ?? true)
		})
		filtersCloseButtons.forEach((button) => {
			button.addEventListener("click", () => {
				setFiltersPanelOpen(false)
				filtersToggle?.focus()
			})
		})
		filtersBackdrop?.addEventListener("click", () => setFiltersPanelOpen(false))
		document.addEventListener("keydown", (event) => {
			if (event.key === "Escape" && isFiltersPanelOpen && !desktopFiltersQuery.matches) {
				setFiltersPanelOpen(false)
				filtersToggle?.focus()
			}
		})

		clearFiltersButtons.forEach((button) => {
			button.addEventListener("click", () => {
				clearAllFilters()
			})
		})

		toggle?.addEventListener("change", () => {
			const url = new URL(window.location.href)
			url.searchParams.set(
				availabilityFilterParam,
				toggle.checked ? "1" : "0,1"
			)
			url.searchParams.delete("page")
			window.location.assign(url)
		})
		window.addEventListener("popstate", () => {
			syncFiltersFromUrl()
		})
		desktopFiltersQuery.addEventListener("change", (event) => {
			setFiltersPanelOpen(event.matches)
		})

		if (toggle && !initialAvailabilityFilter) {
			initialUrl.searchParams.set(availabilityFilterParam, "1")
			initialUrl.searchParams.delete("page")
			window.history.replaceState({}, "", initialUrl)
		}

		if (toggle) {
			toggle.checked = initialAvailabilityFilter !== "0,1"
		}

		setFiltersPanelOpen(desktopFiltersQuery.matches)
		syncFiltersFromUrl()
	})

	const header = document.querySelector(".site-header")
	const headerMenuToggle = document.querySelector("[data-header-menu-toggle]")
	const headerMenu = document.querySelector("[data-header-menu]")
	const headerMenuCloseTriggers = headerMenu
		? headerMenu.querySelectorAll("[data-header-menu-close]")
		: []

	if (header && headerMenuToggle && headerMenu) {
		const firstFocusableSelector =
			'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
		let headerMenuHideTimer = null

		const setMenuOpen = (isOpen) => {
			if (headerMenuHideTimer) {
				window.clearTimeout(headerMenuHideTimer)
				headerMenuHideTimer = null
			}

			header.classList.toggle("site-header--menu-open", isOpen)
			document.body.classList.toggle("site-header-lock", isOpen)
			document.body.classList.toggle("site-header-menu-open", isOpen)
			headerMenuToggle.setAttribute("aria-expanded", String(isOpen))

			if (isOpen) {
				headerMenu.hidden = false
				window.setTimeout(() => {
					const focusTarget =
						headerMenu.querySelector("[data-header-menu-close]") ||
						headerMenu.querySelector(firstFocusableSelector)

					focusTarget?.focus?.()
				}, 0)
			} else {
				headerMenuHideTimer = window.setTimeout(() => {
					headerMenu.hidden = true
				}, 420)
				headerMenuToggle.focus?.()
			}
		}

		headerMenuToggle.addEventListener("click", () => {
			setMenuOpen(!header.classList.contains("site-header--menu-open"))
		})

		headerMenuCloseTriggers.forEach((trigger) => {
			trigger.addEventListener("click", () => setMenuOpen(false))
		})

		headerMenu.addEventListener("click", (event) => {
			if (event.target instanceof HTMLAnchorElement) {
				setMenuOpen(false)
			}
		})

		document.addEventListener("click", (event) => {
			if (!header.classList.contains("site-header--menu-open")) {
				return
			}

			if (!header.contains(event.target)) {
				setMenuOpen(false)
			}
		})

		document.addEventListener("keydown", (event) => {
			if (event.key === "Escape") {
				setMenuOpen(false)
			}
		})

		setMenuOpen(false)
	}

	const bannerItems = document.querySelectorAll("[data-game-banner-item]")

	if (bannerItems.length) {
		const activateItem = (item) => {
			document.body.classList.add("has-banner-hover")
			bannerItems.forEach((bannerItem) =>
				bannerItem.classList.toggle("is-active", bannerItem === item)
			)
		}

		const clearItems = () => {
			document.body.classList.remove("has-banner-hover")
			bannerItems.forEach((bannerItem) =>
				bannerItem.classList.remove("is-active")
			)
		}

		bannerItems.forEach((item) => {
			item.addEventListener("mouseenter", () => activateItem(item))
			item.addEventListener("focusin", () => activateItem(item))
			item.addEventListener("mouseleave", () => {
				window.setTimeout(() => {
					const hoveredItem = document.querySelector(
						"[data-game-banner-item]:hover"
					)

					if (!hoveredItem) {
						clearItems()
					}
				}, 0)
			})
			item.addEventListener("focusout", () => {
				window.setTimeout(() => {
					if (!item.contains(document.activeElement)) {
						const focusedItem = document.querySelector(
							"[data-game-banner-item]:focus-within"
						)

						if (!focusedItem) {
							clearItems()
						}
					}
				}, 0)
			})
		})
	}

	const gameBannerTrack = document.querySelector(".game-banner__track")

	if (gameBannerTrack) {
		const titles = Array.from(
			gameBannerTrack.querySelectorAll(".game-banner__content h2")
		)

		const syncGameBannerTitleSize = () => {
			if (!titles.length) {
				return
			}

			const rootFontSize =
				parseFloat(getComputedStyle(document.documentElement).fontSize) || 16
			const maxSizePx = 2.2 * rootFontSize
			const minSizePx = 1 * rootFontSize
			let currentSizePx = maxSizePx

			gameBannerTrack.style.setProperty(
				"--game-banner-title-size",
				`${currentSizePx}px`
			)

			const fitsAllTitles = () =>
				titles.every((title) => title.scrollWidth <= title.clientWidth + 1)

			while (currentSizePx > minSizePx && !fitsAllTitles()) {
				currentSizePx -= 1
				gameBannerTrack.style.setProperty(
					"--game-banner-title-size",
					`${currentSizePx}px`
				)
			}
		}

		if (typeof ResizeObserver !== "undefined") {
			const resizeObserver = new ResizeObserver(() => syncGameBannerTitleSize())
			resizeObserver.observe(gameBannerTrack)
			titles.forEach((title) => resizeObserver.observe(title))
		}

		if (document.fonts && document.fonts.ready) {
			document.fonts.ready.then(syncGameBannerTitleSize)
		}

		window.addEventListener("load", syncGameBannerTitleSize)
		window.addEventListener("resize", syncGameBannerTitleSize)
		syncGameBannerTitleSize()
	}
})
